import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Post, Delete, Patch, Get } from "../Axios/AxiosFunctions";
import Pagination from "../components/Pagination";
import TableRowsLoader from "../components/TableRowsLoader";
import moment from "moment";
import { BaseURL, apiHeader, recordsLimit } from "../Config/apiUrl";
import { Button } from "react-bootstrap";
import AreYouSureModal from "../components/AreYouSureModal";
// Mui Button
import MuiButton from "@mui/material/Button";
import { IoMdAddCircleOutline } from "react-icons/io";
import { toast } from "react-toastify";
import ScreenBoiler from "../components/ScreenBoiler";
import AddAndEditExamModal from "../components/AddAndEditExamModal";

function ExamScreen() {
  const [limit, setLimit] = useState(recordsLimit);
  const [pageNumber, setPageNumber] = useState(1);
  const accessToken = useSelector((state) => state.authReducer.access_token);
  const [apiData, setApiData] = useState([]);
  const [isGetting, setIsGetting] = useState(false);

  const [isAddAndEditModalOpen, setIsAddAndEditModalOpen] = useState(false);
  const [isAreYouSureModalOpen, setIsAreYouSureModalOpen] = useState(false);
  const [isAddEditApiCall, setIsAddEditApiCall] = useState(false);
  const [isDeleteApiCall, setIsDeleteApiCall] = useState(false);
  const [editingData, setEditingData] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const [lessonsArray, setLessonsArray] = useState([]);
  const [questionArray, setQuestionArray] = useState([]);
  const [activeInActiveApiCall, setActiveInActiveApiCall] = useState(false);


  // get Item handler
  const getData = async (pageNo, newLimit) => {
    const url = BaseURL(`exam/admin?page=${pageNo}&limit=${newLimit}`);

    setIsGetting(true);
    const response = await Get(url, accessToken);
    setIsGetting(false);
    if (response !== undefined) {
      setApiData(response?.data?.data);
    }
  };

  // addAndupdateItemHandler
  const addAndupdateItemHandler = async (params) => {
    params.totalQuestions = params.questions?.length
    const url = BaseURL(
      editingData ? `exam/admin/${editingData?._id}` : `exam/admin`
    );
    const fn = editingData?._id ? Patch : Post;

    setIsAddEditApiCall(true);
    const response = await fn(url, params, apiHeader(accessToken));
    setIsAddEditApiCall(false);

    if (response !== undefined) {
      // if we have updated
      if (editingData) {
        const dataCopy = [...apiData];
        const index = dataCopy.findIndex(
          (item) => item._id === editingData._id
        );
        dataCopy[index] = response.data?.data;
        setApiData(dataCopy);
      }
      // if we have added
      else {
        setApiData((p) => [response.data?.data, ...p]);
      }

      toast.success(`Exam ${editingData ? "Updated" : "Added"} Successfully`);
      setEditingData(null);
      setIsAddAndEditModalOpen(false);
    }
  };

  // deleteItemHandler
  const deleteItemHandler = async () => {
    const url = BaseURL(`exam/admin/${deletingId}`);

    setIsDeleteApiCall(true);
    const response = await Delete(url, null, apiHeader(accessToken));
    setIsDeleteApiCall(false);

    if (response !== undefined) {
      const dataCopy = [...apiData];
      const index = dataCopy.findIndex((item) => item._id === deletingId);
      dataCopy.splice(index, 1);
      setApiData(dataCopy);
      setIsAreYouSureModalOpen(false);
      toast.success(`Exam deleted succeccfully!`);
    }
  };

  // fire on component mount
  useEffect(() => {
    getData(1, limit);
    getLessonsHandler().then((lesson) => getQuestionData(lesson));
  }, []);

  // pagination handler
  const HandlepageChange = (value) => {
    const newPageNumber = pageNumber + value;
    setPageNumber(newPageNumber);
    getData(newPageNumber, limit);
  };

  // get all Lessons
  const getLessonsHandler = async () => {
    const url = BaseURL(`course?noPagination=true`);
    setIsGetting(true);
    const response = await Get(url, accessToken);
    setIsGetting(false);
    if (response !== undefined) {
      setLessonsArray(response?.data?.data);
      return response?.data?.data[0];
    }
  };

  // get Item handler
  const getQuestionData = async (lesson, loader = true) => {
    const url = BaseURL(`question/course/${lesson?._id}?noPagination=true`);

    loader && setIsGetting(true);
    const response = await Get(url, accessToken);
    loader && setIsGetting(false);
    if (response !== undefined) {
      setQuestionArray(response?.data?.data);
    }
  };

  // handleActiveInactive
  const handleActiveInactive = async (isActive, index, id) => {
    const url = BaseURL(`exam/admin/${id}`);
    const params = {
      isActive,
    };

    setActiveInActiveApiCall(true);
    const response = await Patch(url, params, apiHeader(accessToken));
    setActiveInActiveApiCall(false);

    if (response !== undefined) {
      const dataCopy = [...apiData];
      dataCopy[index].isActive = isActive;
      setApiData(dataCopy);
      toast.success(
        `Exam ${isActive ? "Activated" : "Deactivated"} Successfully`
      );
    }
  };

  return (
    <ScreenBoiler>
      <section className="reported-ads mt-5">
        <div className="fieldSetHeaderContainer d-flex flex-column">
          <h1>Exam</h1>
        </div>

        <div className="fieldSetMainContainer">
          <div className="place-add-btn-container mb-4">
            <div className="d-flex align-items-center">
              <p className="m-0 me-3 fw-bold">Records Per Page:</p>
              <select
                value={limit}
                onChange={(e) => {
                  setLimit(e.target.value);
                  setPageNumber(1);
                  HandlepageChange(1, e.target.value);
                }}
                className="px-3 py-2 custom-selection"
              >
                <option value={10} className="pt-2">
                  10
                </option>
                <option value={25}>25</option>
                <option value={50}>50</option>
              </select>
            </div>

            <div className="d-flex align-items-center">
              <MuiButton
                onClick={() => {
                  setEditingData(null);
                  setIsAddAndEditModalOpen(true);
                }}
                variant="contained"
                color="primary"
                className="custom-btn rounded-lg radius-8 ms-4"
                startIcon={<IoMdAddCircleOutline />}
              >
                Add
              </MuiButton>
            </div>
          </div>

          {/* Table */}
          {isGetting ? (
            <TableRowsLoader />
          ) : (
            <div className="col-md-12 table_recent">
              <div className="table-responsive">
                <table
                  className="table"
                  id="dataTable"
                  width="100%"
                  cellspacing="0"
                >
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Duration</th>
                      <th>No. of Attempts</th>
                      <th>Active</th>
                      <th>Last Updated</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {apiData?.map((item, index) => {
                      return (
                        <tr key={item?._id}>
                          <td>{++index}</td>
                          <td className="t-t-c">{item?.examName}</td>
                          <td>{item?.duration} mins</td>
                          <td>{item?.attempts}</td>
                          <td>{item?.isActive ? "Yes" : "No"}</td>
                          <td>
                            {moment(item?.updatedAt).format(
                              "ddd, DD MMM YYYY hh:mm A"
                            )}
                          </td>
                          <td>
                            <ul className="d-flex">
                              <li
                                className="page-item align-self-end me-2"
                                onClick={() => {
                                  setEditingData(item);
                                  setIsAddAndEditModalOpen(true);
                                }}
                              >
                                <Button className="update-btn">Edit</Button>
                              </li>
                              <li
                                className="page-item align-self-end ml-4"
                                onClick={() => {
                                  setDeletingId(item?._id);
                                  setIsAreYouSureModalOpen(true);
                                }}
                              >
                                <Button className="delete-btn">Delete</Button>
                              </li>
                              <li
                                className="page-item align-self-end ml-4 ms-2"
                                onClick={handleActiveInactive.bind(
                                  this,
                                  !item?.isActive,
                                  index - 1,
                                  item?._id
                                )}
                              >
                                <Button
                                  className="update-btn w-120px"
                                  disabled={activeInActiveApiCall}
                                >
                                  {item?.isActive ? "Deactivate" : "Activate"}
                                </Button>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      );
                    })}

                    {apiData?.length == 0 && (
                      <tr className="no-data-table-row">
                        <td colSpan={8}>
                          <div className="d-flex align-items-center justify-content-center no-data-table-content">
                            <p className="">No Data Found!</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          <Pagination
            maxLastLength={limit}
            array={apiData}
            HandlepageChange={HandlepageChange}
            pageNumber={pageNumber}
          />
        </div>

        {/* AreYouSureModal */}
        {isAreYouSureModalOpen && (
          <AreYouSureModal
            open={isAreYouSureModalOpen}
            setOpen={setIsAreYouSureModalOpen}
            label={"Are You Sure?"}
            message={`Do you really want to delete this Exam?`}
            handleYes={deleteItemHandler}
            isLoading={isDeleteApiCall}
          />
        )}

        {isAddAndEditModalOpen && (
          <AddAndEditExamModal
            open={isAddAndEditModalOpen}
            setOpen={setIsAddAndEditModalOpen}
            handleSubmit={addAndupdateItemHandler}
            data={editingData}
            isLoading={isAddEditApiCall}
            questionArray={questionArray}
            lessonsArray={lessonsArray}
            getQuestionData={getQuestionData}
          />
        )}
      </section>
    </ScreenBoiler>
  );
}

export default ExamScreen;
